export default __webpack_public_path__ + "static/media/rainbowlogo.040092ac.gif";